
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success-stories/yeah",
      function () {
        return require("private-next-pages/success-stories/yeah/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/success-stories/yeah"])
      });
    }
  